"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DOMAIN = 'draft-group-upload/';
exports.default = {
  INIT: _DOMAIN + 'INIT',
  CLEAR: _DOMAIN + 'CLEAR',
  UPLOAD_INIT: _DOMAIN + 'UPLOAD_INIT',
  UPLOAD_SUCCESS: _DOMAIN + 'UPLOAD_SUCCESS',
  UPLOAD_FAILURE: _DOMAIN + 'UPLOAD_FAILURE',
  ERROR_DB_GET_GROUP_DATA: _DOMAIN + 'ERROR_DB_GET_GROUP_DATA',
  ERROR_DB_GET_ITEM_DATA: _DOMAIN + 'ERROR_DB_GET_ITEM_DATA',
  ERROR_API_UPLOAD: _DOMAIN + 'ERROR_API_UPLOAD',
  ERROR_DB_MARK_UPLOADED: _DOMAIN + 'ERROR_DB_MARK_UPLOADED'
};